import { AuthProvider } from "config/auth/AuthProvider";
import PrivateRoute from "config/routes/PrivateRoute";
import { lazy, Suspense } from "react";
import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";
import LoadingPage from "views/Base/LoadingPage";
import { accountingFirmRoutes } from "views/AccountingFirm/accountingFirm.routes";
import { usersRoutes } from "views/Collaborators/users.routes";
import { companyRoutes } from "views/Company/company.routes";
import { homeRoutes } from "views/Home/home.routes";
import { accountRoutes } from "views/Profile/account.routes";
import Element from "./Element";

const Page404 = lazy(() => import("views/Base/Page404"));
const Home = lazy(() => import("views/Home/"));

const routers = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/"
      element={
        <AuthProvider>
          <PrivateRoute />
        </AuthProvider>
      }
    >
      {homeRoutes}
      {usersRoutes}
      {accountRoutes}
      {accountingFirmRoutes}
      {companyRoutes}

      <Route
        path="store-token"
        element={
          <Element requiredPermission="none">
            <Home />
          </Element>
        }
      />
      <Route
        path="*"
        element={
          <Suspense fallback={<LoadingPage />}>
            <Page404 />
          </Suspense>
        }
      />
    </Route>,
  ),
);

export { routers };
